import React from 'react';
import {Grid} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {UserRoles} from "../../../utils/roles";
import {Statuses} from "../../../utils/actStatuses";

const useStyles = makeStyles(() => ({
    commentContainer: {
        flexGrow: 1
    },
    paper: {
        width: '100%',
        padding: '12px 16px'
    },
    commentDisabled: {
        "& .MuiInputBase-root.Mui-disabled": {
            color: "black"
        }
    }
}))

const getCommentIsDisabled = (role, status, isStaff)  => {
    if (isStaff) {
        return false
    }
    if (role === UserRoles.PROJECT_MANAGER || role === UserRoles.MODERATOR || role === UserRoles.EDITOR) {
        if (status === Statuses.FOR_APPROVAL_STATUS) {
            return false
        }
        if (status === Statuses.REJECTED_STATUS) {
            return true
        }
    }
    return true
}

export const Comment = ({role, status, isStaff, comments, handleCommentsChange}) => {
    const classes = useStyles()
    return <Grid item container direction={"column"} xs={3}>
            <Paper className={classes.paper}>
                <TextField fullWidth
                           multiline
                           label={'Замечания модератора'}
                           rows={20}
                           value={comments}
                           onChange={handleCommentsChange}
                           variant="outlined"
                           className={classes.commentDisabled}
                           disabled={getCommentIsDisabled(role, status, isStaff)}
                />
            </Paper>
    </Grid>
}